import React from 'react';
import { Box, Text } from '@chakra-ui/react';

interface CompanyMapProps {
  mapIframe?: string;
}

const CompanyMap: React.FC<CompanyMapProps> = ({ mapIframe }) => {
  return (
    <Box className="company-map-container">
      {mapIframe ? (
        <iframe
          className="company-map-iframe"
          width="100%"
          height="300px"
          src={mapIframe}
          title="Flow Autobody Map"
          loading="lazy"
        ></iframe>
      ) : (
        <Text textAlign="center" className="no-map-text">
          No map available
        </Text>
      )}
    </Box>
  );
};

export default CompanyMap;